<template>
  <with-loader id="api-call-detail"
               class="bg-white h-full border-solid border-0 border-l border-gray-a10 px-12"
               :loading="isLoading"
               use-as-overlay
  >
    <div class="flex flex-col mt-8 pb-5 h-full overflow-auto bg-white border-l border-gray-300">
      <span class="font-bold text-gray-dark text-xl">API call</span>

      <span class="text-gray-dark font-semibold mt-4 flex">Request sent</span>
      <JsonPreview :data="requestData" :formData="formData"/>

      <span class="text-gray-dark font-semibold mt-4 flex">Response received</span>
      <JsonPreview :data="responseData" :formData="formData"/>
    </div>
  </with-loader>
</template>

<script>
import WithLoader from '@/components/common/WithLoader.vue'
import JsonPreview from '@/components/analytics/conversations/detail/JsonPreview.vue'

export default {
  name: 'ApiCallDetail',

  components: { JsonPreview, WithLoader },

  props: {
    requestData: {
      type: Object,
      default: null
    },
    responseData: {
      type: Object,
      default: null
    },
    formData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isLoading: false
    }
  }
}
</script>
